import "core-js/modules/es.array.push.js";
export default {
  data() {
    return {};
  },
  props: {
    dataList: {
      Type: Array
    }
  },
  computed: {
    // 计算属性的 超出列表
    beyondList: function () {
      let arr = [];
      let list = this.dataList;

      // console.log('beyong warning');
      // console.dir(list);

      for (var i = 0; i < list.length; i++) {
        if (list[i].num < list[i].usednum) {
          arr.push(list[i]);
        }
      }
      return arr;
    }
  },
  methods: {}
};